/*
 * Mobile hamburger nav — collapses the header's main-nav link row and the
 * "Request Clearance" button behind a toggle on narrow screens.
 *
 * Why this lives in a patch instead of sat-header.liquid's own state: the
 * header snippet is ported markup with no state of its own — every dynamic
 * value it binds to (mobileNavOpen, toggleMobileNav, ...) has to come from
 * renderVals, same as every other patch in this theme. This one just adds
 * a boolean and a setter; the actual show/hide happens in CSS
 * (assets/sat-base.css, [data-m="main-nav"][data-open="true"] etc.) keyed
 * off the data-open attribute this patch renders, so a render never has to
 * compute a big inline style string for something this simple.
 *
 * Auto-close on navigation: without this, tapping a nav link would leave
 * the menu sitting open over whatever page loaded next. There's no single
 * hook that fires on every nav method (goHome, goManifest, goStore, ...),
 * so instead this watches s.page itself — any render where it differs from
 * the last one seen closes the menu, covering every way the page can
 * change without this patch needing to know about each one individually.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var open = false;
  var lastPage = null;

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var s = this.state;

    if (lastPage === null) {
      lastPage = s.page;
    } else if (s.page !== lastPage) {
      lastPage = s.page;
      open = false;
    }

    var self = this;
    out.mobileNavOpen = open;
    out.mobileNavToggleLabel = open ? 'Close menu' : 'Open menu';
    out.toggleMobileNav = function () {
      open = !open;
      self.forceUpdate();
    };

    return out;
  };
})();
